import React from 'react';
import "./Seperator.css";

function Seperator() {
  return (
    <div className="seperator"></div>
  )
}

export default Seperator